<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="modal.show"
                   :data="model"
                   :title="$t(`Create New Branch`)"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>
      <input-widget :autofocus="true" :model="model" attribute="name"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import BranchModel from "./Branch.model";
  import {createNamespacedHelpers} from "vuex";

  const {mapState, mapActions} = createNamespacedHelpers('setup/branch');

  export default {
    name: "BranchModal",
    components: {InputWidget, ArtisioModal},
    data() {
      return {
        loading: false,
        // This indicates that modal should show confirmation dialog when something is changed inside, and we are trying
        // to close the modal
        showConfirmation: true,
        model: new BranchModel(),
      }
    },
    computed: {
      ...mapState(['modal']),
    },
    methods: {
      ...mapActions(['hideModal', 'createBranch']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new BranchModel();
        this.hideModal();
      },
      async onSubmit() {
        this.loading = true;
        const response = await this.createBranch({
          name: this.model.name
        });
        this.loading = false;
        if (response.success) {
          this.$toast('success', this.$t('Branch was successfully added'));

          this.showConfirmation = false;
          this.hideModal();
        } else {
          this.model.setMultipleErrors(response.body);
        }
      },
    }
  }
</script>

<style scoped>

</style>
